import { useSelector } from 'react-redux';
import { groupBy, keys, sortBy } from 'lodash';
import { CONNECTORS_RESOURCE_TYPES } from 'js/constants/resourceTypes';
import { useFeatureFlag } from '../useFeatureFlags';
import flowTypes from 'new/components/flows/types/flowTypes';
import { CDC_FLOW_WITH_DB_READ_ONLY_CONNECTORS } from 'js/constants/connectionCategories';

export default function useConnections(
  connectionType = CONNECTORS_RESOURCE_TYPES.SOURCE,
  flowType = 'streaming',
  overrideConnections: string[] = [],
) {
  const paging = useSelector((state: any) => state.paging);
  const isCDCv2Enabled = useFeatureFlag('UI_ENABLE_CDC_V2');
  const connectionMetas = paging.metaInfoById;
  const connectionsByFlowType = paging.connectionsByFlowType[flowType];
  const connType = connectionType.toLocaleLowerCase();
  const soonForFlowType = paging.soonForFlowTypes[flowType];
  let connectionTypes: string[];
  let connectionsAllowed: string[];

  if (overrideConnections.length) {
    connectionTypes = overrideConnections;
    connectionsAllowed = overrideConnections;
  } else {
    connectionTypes =
      connectionType === CONNECTORS_RESOURCE_TYPES.SOURCE
        ? paging.sourcesSupported
        : paging.sinksSupported;
    connectionsAllowed =
      connectionType === CONNECTORS_RESOURCE_TYPES.SOURCE
        ? paging.sourcesAllowed
        : paging.sinksAllowed;

    connectionTypes = connectionTypes.filter(
      (type) =>
        connectionsByFlowType[connType].includes(type) || soonForFlowType[connType].includes(type),
    );
    connectionsAllowed = connectionTypes.filter(
      (type) =>
        connectionsByFlowType[connType].includes(type) || soonForFlowType[connType].includes(type),
    );

    // exclude netsuite for cdc flow based on the feature flag
    if (flowType === flowTypes.cdc && !isCDCv2Enabled) {
      connectionsAllowed = connectionsAllowed.filter(
        (type) => !CDC_FLOW_WITH_DB_READ_ONLY_CONNECTORS.includes(type),
      );
    }
  }

  const groupedConnections = groupBy(connectionTypes, (type) => {
    if (connectionsAllowed.indexOf(type) === -1) {
      return 'Coming Soon';
    }
    return connectionMetas[type].industryCategory;
  });
  const industryCategories = sortBy(keys(groupedConnections));

  return {
    connectionsByCategory: {
      All: connectionsAllowed,
      ...groupedConnections,
    },
    connectionsComingSoon: soonForFlowType?.[connType],
    categories: ['All', ...industryCategories],
  };
}
